import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import { Avatar, Box, Grid, Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { buttonsAvailable } from 'layouts/PruffConnect/SideBar/buttonsAvailable';
import CustomButton from 'lib/designSystem/Button';
import Card from 'lib/designSystem/Card';
import IconWrapper from 'lib/designSystem/IconWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'services/redux/store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3),
    },
    welcomeCard: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      color: 'white',
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    avatar: {
      width: 64,
      height: 64,
      marginRight: theme.spacing(2),
      backgroundColor: 'white',
      color: theme.palette.primary.main,
    },
    productIcon: {
      fontSize: 48,
      marginBottom: theme.spacing(2),
      color: theme.palette.primary.main,
    },
    productTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(2),
      color: theme.palette.text.primary,
    },
    productDescription: {
      color: theme.palette.text.secondary,
      lineHeight: 1.6,
      marginBottom: theme.spacing(3),
      flex: 1,
    },
    sectionTitle: {
      marginBottom: theme.spacing(3),
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  }),
);

const PruffConnectHome = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const auth = useSelector((state: RootState) => state.auth);
  const clientCompanyTypes = useSelector(
    (state: RootState) => state.clientCompanyTypes,
  );
  const user = auth.user;

  const handleProductClick = (id: string) => {
    navigate(`/${id}`);
  };

  const getAvailableProducts = () => {
    const products = [];
    const availableTypes = clientCompanyTypes?.types?.map(
      (type) => type.typeId,
    );

    // Factoring
    if (availableTypes?.includes('factoring')) {
      products.push({
        id: 'factoring',
        name: buttonsAvailable.factoring.label,
        description: 'Gestión de facturas y cobranza',
        path: buttonsAvailable.factoring.id,
        icon: buttonsAvailable.factoring.icon,
      });
    }

    // SGR
    if (availableTypes?.includes('sgr')) {
      products.push({
        id: 'sgr',
        name: buttonsAvailable.sgr.label,
        description: 'Acceso a servicios de garantía',
        path: buttonsAvailable.sgr.id,
        icon: buttonsAvailable.sgr.icon,
      });
    }

    // Crédito
    if (availableTypes?.includes('credit')) {
      products.push({
        id: 'credit',
        name: buttonsAvailable.credit.label,
        description: 'Financiamiento empresarial',
        path: buttonsAvailable.credit.id,
        icon: buttonsAvailable.credit.icon,
      });
    }

    return products;
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.welcomeCard}>
        <div className={classes.userInfo}>
          <Avatar className={classes.avatar}>
            <AccountCircleIcon fontSize="large" />
          </Avatar>
          <Typography variant="h4" gutterBottom>
            ¡Bienvenido, {user?.name}!
          </Typography>
        </div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" mb={2}>
              <IconWrapper color="primary" sx={{ mr: 1 }}>
                <BusinessIcon />
              </IconWrapper>
              <Typography variant="body1">
                Empresa: {user?.companyName}
              </Typography>
            </Box>
            <Box display="flex" alignItems="center">
              <IconWrapper color="primary" sx={{ mr: 1 }}>
                <EmailIcon />
              </IconWrapper>
              <Typography variant="body1">Email: {user?.email}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Typography variant="h5" className={classes.sectionTitle}>
        Accesos Rápidos
      </Typography>
      <Grid container spacing={3}>
        {getAvailableProducts().map((product) => (
          <Grid item xs={12} md={4} key={product.id}>
            <Card>
              <Box className={classes.productIcon}>
                <IconWrapper color="primary">{product.icon}</IconWrapper>
              </Box>
              <Typography variant="h6" className={classes.productTitle}>
                {product.name}
              </Typography>
              <Typography
                variant="body2"
                className={classes.productDescription}
              >
                {product.description}
              </Typography>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleProductClick(product.path);
                }}
              >
                Acceder
              </CustomButton>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default PruffConnectHome;
